import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { useTranslation } from '@hooks';
import { Subtitle3, Caption2, H3, Text2 } from '@components/styles/Typography';
import { colors } from 'styles/variables';
import { useState } from 'react';
import { CloseButton, RightModal } from '@components/ui';
import Size from './Size';

const ProductColors = ({ colorsPhoto, withTitle, productID, currentColor }) => {
    const { t, locale } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const router = useRouter();
    const isProdRequest = !!router.query['production-request'];

    const openModal = () => {
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
    };
    return (
        <Wrapper data-testid="product-colors">
            {withTitle && (
                <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                    <TitleWrapper>
                        <Subtitle3>{t('productColor')}:</Subtitle3>
                        <Caption2>{currentColor[locale]}</Caption2>
                    </TitleWrapper>
                    <Text2
                        onClick={openModal}
                        style={{
                            textDecoration: 'underline',
                            color: colors.bgGray25,
                            cursor: 'pointer',
                        }}
                    >
                        {t('productSizeTable')}
                    </Text2>
                </div>
            )}
            <ColorWrapper>
                {colorsPhoto?.map((photo) => {
                    if (isProdRequest) {
                        return (
                            <Link
                                key={photo.id}
                                to={`/${t('productSlug')}/${
                                    photo.slug[locale]
                                }?production-request=true`}
                                href={`/${t('productSlug')}/${
                                    photo.slug[locale]
                                }?production-request=true`}
                                aria-label={photo.slug[locale]}
                                passHref
                            >
                                <Color isCurrentColor={photo.id === productID}>
                                    <Image
                                        src={photo.images[0].urls.thumb}
                                        alt={photo.slug[locale]}
                                        width={54}
                                        height={80}
                                        loading="eager"
                                    />
                                </Color>
                            </Link>
                        );
                    }

                    return photo.pack_count > 0 ? (
                        <Link
                            key={photo.id}
                            to={`/${t('productSlug')}/${photo.slug[locale]}`}
                            href={`/${t('productSlug')}/${photo.slug[locale]}`}
                            aria-label={photo.slug[locale]}
                            passHref
                        >
                            <Color isCurrentColor={photo.id === productID}>
                                <Image
                                    src={photo.images[0].urls.thumb}
                                    alt={photo.slug[locale]}
                                    width={54}
                                    height={80}
                                    loading="eager"
                                />
                            </Color>
                        </Link>
                    ) : null;
                })}
            </ColorWrapper>
            <RightModal
                isOpen={isOpen}
                closeModal={closeModal}
                noOverlay
                width="44vw"
            >
                <TableWrapper>
                    <CloseButton
                        close={closeModal}
                        right
                        top="42px"
                        padding="0"
                    />
                    <H3>{t('sizeTable')}</H3>
                    <Size />
                </TableWrapper>
            </RightModal>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    position: relative;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    margin-top: 8px;
    margin-bottom: 24px;
    min-height: 113px;
    scrollbar-width: none;

    ::-webkit-scrollbar {
        display: none;
        scrollbar-width: none;
    }

    @media (max-width: 1024px) {
        margin-top: 20px;
        margin-bottom: auto;
        display: flex;
        flex-direction: column;
    }
`;
const ColorWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    margin-top: 8px;
    overflow-x: scroll;
    overflow-y: hidden;
    gap: 8px;
    scrollbar-width: none;

    ::-webkit-scrollbar {
        display: none;
        scrollbar-width: none;
    }
`;
const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;
const Color = styled.div`
    width: 54px;
    min-width: 54px;
    height: 80px;

    img {
        border: ${({ isCurrentColor }) => isCurrentColor && '1px solid black'};
    }
`;

const TableWrapper = styled.div`
    width: fit-content;
    margin: 150px auto 0;
`;
export default ProductColors;
